<template>
  <component :is="homeComponent" />
</template>

<script>
import { mapState } from "vuex";
import LegacyMemberHome from "./memberHome/index.vue";
import NewMemberHome from "../memberDashboardV2/home/Index.vue";
import { isAmpiMember } from "@/common/memberDashboardRouting";

export default {
  name: "MemberHomeEntry",
  components: {
    LegacyMemberHome,
    NewMemberHome,
  },
  computed: {
    ...mapState("user", ["user"]),
    homeComponent() {
      return isAmpiMember(this.user) ? LegacyMemberHome : NewMemberHome;
    },
  },
};
</script>
